import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["flow", "excludedSteps", "keepAlive", "scrollToTop", "scrollTargetYOffset", "info", "header", "wrapperCol", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CloseOutlined, InfoOutlined } from '@ant-design/icons';
import QuotationMarks from "../../public/icons/quotation_marks.svg";
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuLink from "../DixuLink/DixuLink";
import DixuText from "../DixuText/DixuText";
import { range, sortedUniq } from 'lodash';
import DixuLogo from "../../public/icons/dixu.svg";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { clamp } from "../../utils/MathUtils";
import { toRem } from "../../utils/Utils";
const DixuStepFlowStep = _ref => {
  let {
    active,
    keepAlive,
    children
  } = _ref;
  const classes = classNames('dixu-step-flow__step');
  if (!active && !keepAlive) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: {
      display: active ? 'block' : 'none'
    }
  }, /*#__PURE__*/React.createElement(DixuText, {
    weight: "medium"
  }, children));
};
DixuStepFlowStep.defaultProps = {
  active: false
};
const DixuStepFlow = _ref2 => {
  let {
      flow,
      excludedSteps,
      keepAlive,
      scrollToTop,
      scrollTargetYOffset,
      info,
      header,
      wrapperCol,
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const {
    currentStep,
    _setStepCount: setStepCount,
    _setExcludedSteps: setExcludedSteps
  } = flow;
  const {
    0: infoOpen,
    1: setInfoOpen
  } = useState(false);
  const classes = classNames('dixu-step-flow', className);
  const infoWrapperClasses = classNames('dixu-step-flow-info-wrapper');
  const scrollTargetRef = useRef();
  const infoRef = useRef();
  const stepsContainerRef = useRef();
  const mappedChildren = React.Children.map(children, (child, index) => {
    const {
      props
    } = child;
    const active = currentStep === index;
    const newProps = _objectSpread(_objectSpread({
      key: index.toString(36),
      keepAlive: keepAlive && !excludedSteps.includes(index)
    }, props), {}, {
      active
    });
    if (child.type === DixuStepFlowStep) {
      return /*#__PURE__*/React.cloneElement(child, newProps);
    }
    return /*#__PURE__*/React.createElement(DixuStepFlowStep, newProps, child);
  });
  const childCount = mappedChildren.length;
  const scrollTargetStyle = {
    position: 'relative',
    top: toRem(scrollTargetYOffset)
  };
  const stepContent = /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), scrollToTop && /*#__PURE__*/React.createElement("div", {
    ref: scrollTargetRef,
    style: scrollTargetStyle,
    tabIndex: "-1"
  }), mappedChildren);
  useEffect(() => {
    setStepCount(childCount);
  }, [childCount]);
  useEffect(() => {
    setExcludedSteps(excludedSteps);
  }, [excludedSteps]);
  useEffect(() => {
    if (infoOpen && info && !info[currentStep]) {
      setInfoOpen(false);
    }
  }, [info, infoOpen]);
  useEffect(() => {
    if (scrollToTop) {
      scrollTargetRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
      scrollTargetRef.current?.focus({
        preventScroll: true
      });
    }
  }, [currentStep, scrollToTop]);
  useEffect(() => {
    setInfoOpen(false);

    // Scroll to top (Safari fix).
    if (stepsContainerRef.current) {
      stepsContainerRef.current.scrollTop = 0;
    }
  }, [currentStep]);
  useEffect(() => {
    if (infoRef.current) {
      infoRef.current.scrollTop = 0;
    }
  }, [infoOpen, currentStep]);
  if (info) {
    const mappedInfos = info.map((infoContent, index) => {
      let displayedContent = infoContent;
      if (typeof infoContent === 'string' || infoContent?.quote) {
        const content = typeof infoContent === 'string' ? infoContent : infoContent?.content;
        displayedContent = /*#__PURE__*/React.createElement(DixuRow, {
          gutter: [0, 28]
        }, /*#__PURE__*/React.createElement(DixuCol, {
          span: 24
        }, /*#__PURE__*/React.createElement(DixuText, {
          fill: "1-5"
        }, /*#__PURE__*/React.createElement(QuotationMarks, {
          style: {
            height: toRem(32)
          }
        }))), /*#__PURE__*/React.createElement(DixuCol, {
          span: 24
        }, /*#__PURE__*/React.createElement(DixuText, {
          weight: "medium"
        }, content)));
      }
      return /*#__PURE__*/React.createElement(DixuStepFlowStep, {
        active: index === currentStep,
        key: index.toString(36)
      }, displayedContent);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: infoWrapperClasses
    }, /*#__PURE__*/React.createElement("div", {
      ref: infoRef,
      className: classNames('dixu-step-flow-info-wrapper__info-container', {
        'dixu-step-flow-info-wrapper__info-container--open': infoOpen
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('dixu-step-flow-info-wrapper__info-header', {
        'dixu-step-flow-info-wrapper__info-header--open': infoOpen
      })
    }, /*#__PURE__*/React.createElement(DixuLink, {
      href: "/"
    }, /*#__PURE__*/React.createElement(DixuLogo, null))), /*#__PURE__*/React.createElement("div", {
      className: "dixu-step-flow-info-wrapper__info-content"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuText, {
      font: "4",
      color: "2-1",
      weight: "medium",
      block: true
    }, mappedInfos)))), /*#__PURE__*/React.createElement("div", {
      ref: stepsContainerRef,
      className: classNames('dixu-step-flow-info-wrapper__steps-container', {
        'dixu-step-flow-info-wrapper__steps-container--with-header': header
      })
    }, header && /*#__PURE__*/React.createElement("div", {
      className: "dixu-step-flow-info-wrapper__steps-header"
    }, header), /*#__PURE__*/React.createElement("div", {
      className: "dixu-step-flow-info-wrapper__steps-content"
    }, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center"
    }, /*#__PURE__*/React.createElement(DixuCol, wrapperCol, stepContent)))), !!info[currentStep] && /*#__PURE__*/React.createElement("div", {
      className: classNames('dixu-step-flow-info-wrapper__info-toggle-wrapper', {
        'dixu-step-flow-info-wrapper__info-toggle-wrapper--open': infoOpen
      })
    }, /*#__PURE__*/React.createElement(DixuButton, {
      type: "primary",
      modifierType: "circle",
      block: false,
      onClick: () => {
        setInfoOpen(!infoOpen);
      },
      icon: infoOpen ? /*#__PURE__*/React.createElement(CloseOutlined, null) : /*#__PURE__*/React.createElement(InfoOutlined, null),
      className: classNames('dixu-step-flow-info-wrapper__info-toggle', {
        'dixu-step-flow-info-wrapper__info-toggle--close': infoOpen
      })
    })));
  }
  return stepContent;
};
DixuStepFlow.defaultProps = {
  excludedSteps: [],
  keepAlive: false,
  scrollToTop: true,
  scrollTargetYOffset: -16,
  info: undefined,
  header: undefined,
  wrapperCol: {
    xs: 24,
    md: 18,
    xl: 17
  }
};
DixuStepFlow.useFlow = () => {
  const {
    0: currentStep,
    1: setCurrentStep
  } = useState(0);
  const currentStepRef = useRef(currentStep);
  currentStepRef.current = currentStep;
  const {
    0: stepCount,
    1: setStepCount
  } = useState(0);
  const stepCountRef = useRef(stepCount);
  stepCountRef.current = stepCount;
  const {
    0: excludedSteps,
    1: setExcludedSteps
  } = useState([]);
  const excludedStepsCount = excludedSteps.length;
  const adjustedStepCount = stepCount - excludedStepsCount;
  const stepIndexes = useMemo(() => {
    return range(stepCount);
  }, [stepCount]);
  const sortedUniqueExcludedSteps = useMemo(() => {
    return sortedUniq([...excludedSteps].sort((a, b) => a - b));
  }, [excludedSteps]);
  const currentStepAdjustValue = sortedUniqueExcludedSteps.filter(e => e <= currentStep).length;
  const adjustedCurrentStep = currentStep - currentStepAdjustValue;
  const clampStep = useCallback(step => {
    return clamp(step, 0, stepCountRef.current - 1);
  }, [stepCountRef.current]);
  const goToStep = useCallback(step => {
    const resolvedStep = (() => {
      if (excludedSteps.length > 0) {
        const matchIndex = sortedUniqueExcludedSteps.indexOf(step);
        if (matchIndex !== -1) {
          const nextIncludedStep = stepIndexes.slice(...(() => {
            if (step < currentStepRef.current) {
              return [0, step];
            }
            return [step + 1];
          })()).sort((() => {
            if (step < currentStepRef.current) {
              return (a, b) => b - a;
            }
            return (a, b) => a - b;
          })()).find(e => !excludedSteps.includes(e));
          return nextIncludedStep;
        }
      }
      return step;
    })();
    if (resolvedStep != null) {
      setCurrentStep(clampStep(resolvedStep));
    }
  }, [excludedSteps, sortedUniqueExcludedSteps, stepIndexes, clampStep]);
  const goToNextStep = () => {
    goToStep(currentStepRef.current + 1);
  };
  const goToPreviousStep = () => {
    goToStep(currentStepRef.current - 1);
  };
  useEffect(() => {
    goToStep(currentStepRef.current);
  }, [stepCount, excludedSteps, goToStep]);
  const isFirstStep = currentStepRef.current === stepIndexes.filter(e => !sortedUniqueExcludedSteps.includes(e))[0];
  const isLastStep = currentStepRef.current === [...stepIndexes].reverse().filter(e => !sortedUniqueExcludedSteps.includes(e))[0];
  return [{
    currentStep,
    stepCount,
    excludedSteps,
    goToStep,
    goToNextStep,
    goToPreviousStep,
    isFirstStep,
    isLastStep,
    currentStepIndicator: `${adjustedCurrentStep + 1}/${adjustedStepCount}`,
    _setStepCount: setStepCount,
    _setExcludedSteps: setExcludedSteps
  }];
};
DixuStepFlow.Step = DixuStepFlowStep;
export default DixuStepFlow;